<template>
    <v-row class="ma-n1">
        <v-col class="pa-1">
            <v-text-field v-model="query['searchDateValue'][0]" label="검색기간(시작)" type="date" max="2999-12-31" clearable v-bind="attrs" />
        </v-col>
        <v-col class="pa-1">
            <v-text-field v-model="query['searchDateValue'][1]" label="검색기간(종료)" type="date" max="2999-12-31" clearable v-bind="attrs" />
        </v-col>
        <v-col class="pa-1">
            <v-select v-model="query['searchKey']" :items="searchKeys" label="검색대상" placeholder="전체" clearable v-bind="attrs" />
        </v-col>
        <v-col class="pa-1">
            <v-text-field v-model="query['searchValue']" label="검색어" append-icon="mdi-magnify" clearable v-bind="attrs" @click:append="emit" @keydown.enter="emit" />
        </v-col>
        <v-col class="pa-1" cols="auto" v-if="detect == 'pc'">
            <v-btn color="primary" height="100%" @click="emit">검색</v-btn>
        </v-col>
    </v-row>
</template>

<script>
import dayjs from "dayjs";
import detect from "@/plugins/detect";

const initQuery = (query = {}) => ({
    ...(query || {}),

    ["searchDateValue"]: [...(query["searchDateValue"] ?? [null, null])],

    ["searchKey"]: query?.["searchKey"] ?? null,
    ["searchValue"]: query?.["searchValue"] ?? null,
});

const attrs = {
    dense: true,
    outlined: true,
    persistentPlaceholder: true,
    hideDetails: true,
};

const searchKeys = [
    //
    // { text: "상품명", value: "purchases.product.name" },
    { text: "주문번호", value: "orderNo" },
];

export default {
    data: () => ({
        query: initQuery(),

        attrs,
        detect,
        searchKeys,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        "$route.query"() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            let { ...query } = this.query;

            delete query.page;

            if (!query["searchDateValue"][0] && !query["searchDateValue"][1]) delete query["searchDateValue"];

            if (!query?.["searchKey"]) delete query["searchKey"];
            if (!query?.["searchValue"]) delete query["searchValue"];

            this.$router.push({ query });
        },
    },
};
</script>

<style lang="scss" scoped>
.v-btn-toggle > .v-btn.v-btn--active {
    opacity: 1;
}
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn--active.white {
    border-width: 1px;
    border-style: solid;
    border-color: var(--v-primary-base) !important;
}
</style>
